// In your separate file (dummyProducts.js)
export const dummyProducts = [
    {
      id: 1,
      product: 'Apple',
      description: 'This is a dummy product 1',
      category: 'Fruits',
      image: `https://source.unsplash.com/random/200x200?sig=${Math.random()}`,
      price: 9.99,
      instock: 5,
      rating: 4.5,
    },
    {
      id: 2,
      product: 'Mango',
      description: 'This is a dummy product 2',
      category: 'Fruits',
      image: `https://source.unsplash.com/random/200x200?sig=${Math.random()}`,
      price: 12.99,
      instock: 3,
      rating: 3.7,
    },
    {
      id: 3,
      product: 'Banana',
      description: 'This is a dummy product 3',
      category: 'Fruits',
      image: `https://source.unsplash.com/random/200x200?sig=${Math.random()}`,
      price: 2.99,
      instock: 10,
      rating: 4.0,
    },
    {
      id: 4,
      product: 'Bread',
      description: 'This is a dummy product 4',
      category: 'Bakery',
      image: `https://source.unsplash.com/random/200x200?sig=${Math.random()}`,
      price: 3.49,
      instock: 8,
      rating: 4.2,
    },
    {
      id: 5,
      product: 'Milk',
      description: 'This is a dummy product 5',
      category: 'Dairy',
      image: `https://source.unsplash.com/random/200x200?sig=${Math.random()}`,
      price: 2.19,
      instock: 15,
      rating: 4.8,
    },
    // Add more grocery items here
    {
      id: 6,
      product: 'Carrots',
      description: 'This is a dummy product 6',
      category: 'Vegetables',
      image: `https://source.unsplash.com/random/200x200?sig=${Math.random()}`,
      price: 1.99,
      instock: 12,
      rating: 4.2,
    },
    {
      id: 7,
      product: 'Rice',
      description: 'This is a dummy product 7',
      category: 'Grains',
      image: `https://source.unsplash.com/random/200x200?sig=${Math.random()}`,
      price: 4.49,
      instock: 20,
      rating: 4.6,
    },
    {
      id: 8,
      product: 'Chicken',
      description: 'This is a dummy product 8',
      category: 'Meat',
      image: `https://source.unsplash.com/random/200x200?sig=${Math.random()}`,
      price: 7.99,
      instock: 6,
      rating: 4.3,
    },
    {
      id: 9,
      product: 'Butter',
      description: 'This is a dummy product 9',
      category: 'Bakery',
      image: `https://source.unsplash.com/random/200x200?sig=${Math.random()}`,
      price: 9.39,
      instock: 3,
      rating: 4.7,
    },
  ];
  